<template>
  <div>
    <HeaderBreadcrumbs :title="'Dynamic AX'" :items="[
      { label: 'All Dynamic AX' },
    ]" />
    <div class="bg-white p-0 my-3 rounded-lg shadow-sm">
      <div class="flex px-4 py-3 justify-between items-center">
        <div class="relative">
          <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" width="20" height="20"
            fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 2a8 8 0 016.32 12.906l4.387 4.387a1 1 0 01-1.415 1.415l-4.387-4.387A8 8 0 1110 2zm0 2a6 6 0 100 12 6 6 0 000-12z" />
          </svg>
          <input placeholder="Search Product Name, Vendor Name, Pis No..."
            class="p-2.5 pl-5 w-96 text-sm text not-italic border rounded-lg"  v-model="searchForm"
            @input="debounceSearch" v-on:keyup.enter="fetchData" />
          <button v-if="searchForm"
            class="absolute top-1/2 right-3 transform -translate-y-1/2  text-gray-500 active:border" @click="reset"
            title="Clear search">
            ✕
          </button>
        </div>
        <div>
          <t-dropdown>
            <div slot="trigger" slot-scope="{ mousedownHandler, focusHandler, blurHandler, keydownHandler }"
              class="flex z-50">
              <button
                class="flex items-center relative justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg"
                @mousedown="mousedownHandler" @focus="focusHandler" @blur="blurHandler" @keydown="keydownHandler">
                <svg class="w-4 h-4 mr-1 text-gray-600 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z" />
                </svg>
                Filter
                <svg class="w-5 h-5 ml-1 text-gray-600 fill-current" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <polygon
                    points="9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8" />
                </svg>
                <div v-if="dataBadge"
                  class="rounded-full w-5 h-5 bg-red-600 absolute -top-2 -right-2 text-white text-xs flex justify-center items-center">
                  {{ dataBadge }}
                </div>
              </button>
            </div>
            <div class="w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg"
              slot-scope="{ hide, blurHandler }">
              <div
                class="block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100"
                role="menuitem">
                <div class="flex justify-between mb-3 mt-2">
                  <div>Filter</div>
                  <div @click="hide">
                    <svg class="w-4 h-4 text-gray-800 dark:text-white cursor-pointer" aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>
                  </div>
                </div>
                <label class="text-gray-600 font-semibold mb-3 mt-2">Status</label>
                <FilterComponent v-model="itemStatus" :options="statusOptions" :defaultText="'Select Order Status'" />
                <div class="mt-3">
                  <button class="border bg-blue-500 px-4 py-2 text-white rounded-lg" @click="fetchData()"
                    @blur="blurHandler">
                    Filter
                  </button>
                  <button class="border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2" @click="reset()"
                    @blur="blurHandler">Reset</button>
                </div>

              </div>

            </div>
          </t-dropdown>
        </div>
      </div>
      <Table :headers="headers" :data="items"
      :withScrollX="true"
      :sticky-columns="['no','product_name']"
      :row-key="['product_name', 'external_itemid', 'discount', 'vendor_name', 'vendor_account', 'status_item', 'pisnumber', 'dynamics_id', 'status_message', 'releasedate_dymamics', 'created', 'modified']"
        :current-page="currentPage" :isLoading="isLoading" :per-page="20">
        <template #header-create="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                </svg>
              </span>
            </button>
          </div>
        </template>
        <template #product_name="{ row }">
          <router-link class="text-blue-700 sticky-column hover:no-underline font-medium leading-2 cursor-pointer" :to="{
      path:
        '/items/detail/' +
        row.external_itemid?.toString().replace(/\D/g, ''),
    }">
            {{ row.product_name }}
          </router-link>
        </template>
        <template #header-modified="{ column }">
          <div class="flex items-center gap-1">
            {{ column.label }}
            <button @click="sortBy(column.key)" class="text-xs text-gray-500">
              <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                </svg>
              </span>
            </button>
          </div>
        </template>

        <template #status_item="{ value }">
          <div class="px-2 py-1 text-center rounded-lg text-xs font-medium capitalize" :class="statusColor(value)">
            {{ statusText(value) }}
          </div>
        </template>
        <template #actions="{ row }">
          <t-dropdown>
            <div slot="trigger" slot-scope="{
                mousedownHandler,
                focusHandler,
                blurHandler,
                keydownHandler,
                isShown
              }"
              class=" relative"
              >
              <button id="user-menu" :class="{ ' text-gray-500 ': isShown }" aria-label="User menu" aria-haspopup="true"
                @focus.stop="focusHandler" @blur.stop="blurHandler" @keydown.stop="keydownHandler"
                @click.stop="mousedownHandler" class="cursor-pointer focus:outline-none">
                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                    d="M6 12h.01m6 0h.01m5.99 0h.01" />
                </svg>
              </button>
            </div>
            <div slot-scope="{ hide, blurHandler }" class="absolute -top-custom z-10 bg-white w-60 shadow-sm right-4 rounded-lg ">
              <button
                class="block text-left w-full px-4 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                role="menuitem" @click.stop="hide" @blur="blurHandler">

                <button class="flex justify-start items-center w-full" @click="handleModalJson(row)">
                  <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path fill-rule="evenodd"
                      d="M4.998 7.78C6.729 6.345 9.198 5 12 5c2.802 0 5.27 1.345 7.002 2.78a12.713 12.713 0 0 1 2.096 2.183c.253.344.465.682.618.997.14.286.284.658.284 1.04s-.145.754-.284 1.04a6.6 6.6 0 0 1-.618.997 12.712 12.712 0 0 1-2.096 2.183C17.271 17.655 14.802 19 12 19c-2.802 0-5.27-1.345-7.002-2.78a12.712 12.712 0 0 1-2.096-2.183 6.6 6.6 0 0 1-.618-.997C2.144 12.754 2 12.382 2 12s.145-.754.284-1.04c.153-.315.365-.653.618-.997A12.714 12.714 0 0 1 4.998 7.78ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                      clip-rule="evenodd" />
                  </svg>
                  <span class="ml-2 text-sm"> View Detail</span>
                </button>
              </button>
              <button :disabled="row.status_item == rejected || row.status_item == 10"
                :class="row.status_item == rejected || row.status_item == 10 ? 'pointer-events-auto' : 'pointer-events-none'"
                class="block text-left w-full px-4 py-2 text-sm  leading-5 text-gray-500 transition duration-150 ease-in-out hover:no-underline hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                role="menuitem" @click.stop="hide" @blur="blurHandler">


                <router-link
                  :class="row.status_item == rejected || row.status_item == 10 ? 'opacity-1 cursor-pointer' : 'opacity-50 cursor-not-allowed '"
                  :to="{ path: `/ax/items/register-item-ax/${row.id}` }"
                  class="link text-gray-600 hover:no-underline hover:text-gray-600  items-center flex  justify-start">
                  <button class="flex justify-start items-center w-full">
                    <svg class="w-6 h-6 text-gray-600 dark:text-white" aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                      <path fill-rule="evenodd"
                        d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                        clip-rule="evenodd" />
                      <path fill-rule="evenodd"
                        d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                        clip-rule="evenodd" />
                    </svg>
                    <span class="ml-2 text-sm">Edit</span>
                  </button>

                </router-link>

              </button>
              <button @click="resendItem(row.id)"
                :class="row.status_item == rejected || row.status_item == 10 ? 'pointer-events-auto' : 'pointer-events-none'"
                class=" block text-left w-full px-4 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:no-underline hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                role="menuitem" @click.stop="hide" @blur="blurHandler">
                <div class="flex justify-start" :disabled="row.status_item == rejected || row.status_item == 10"
                  :class="row.status_item == rejected || row.status_item == 10 ? 'opacity-1 cursor-pointer' : 'opacity-50 cursor-not-allowed '">
                  <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m16 10 3-3m0 0-3-3m3 3H5v3m3 4-3 3m0 0 3 3m-3-3h14v-3" />
                  </svg>

                  <span class="ml-2 text-sm">Resend</span>
                </div>

              </button>

            </div>
          </t-dropdown>
        </template>
        <template #created="{ value }">
          <span class="text-sm">{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
        <template #releasedate_dymamics="{ value }">
          <span>
            {{ value ? epochConvert(value).date : '-' }}
          </span>
          <br>
          <span class="italic text-xs">
            {{ value ? epochConvert(value).time : '' }}
          </span>
        </template>

        <template #modified="{ value }">
          <span>{{ formatDate(value).date }}</span>
          <br>
          <span class="italic text-xs">{{ formatDate(value).time }}</span>
        </template>
      </Table>
      <div v-if="totalRows / perPage > 1" class="flex justify-between ml-1 px-3 items-center mt-3">
        <div class="font-semibold">
          <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
            class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
        </div>
        <div class="mb-2">
          <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage" class="rounded-lg" />
        </div>
      </div>
    </div>
    <t-modal ref="modalLogJson">
      <div class="text-sm flex-col">
        <div class="json-block">
          <pre>{{ JSON.stringify(this.detailsData, null, 2) }}</pre>
        </div>
      </div>
    </t-modal>
  </div>

</template>

<script>
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import constant from '../../store/constant';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import FilterComponent from '@/components/form/StatusFilterComponent.vue'
import Table from '@/components/form/table'
import API from '../../plugins/http';
import { EventBus } from '../../event-bus'
const itemStatus = Object.entries(constant.ITEM_STATUS_REGISTER_AX).map(
  (val) => ({
    value: val[1],
    text: val[0],
  }),
);
export default {
  name: 'RegisterItemAx',
  components: {
    HeaderBreadcrumbs,
    FilterComponent,
    Table
  },
  data() {
    return {
      rejected: constant.ITEM_STATUS_REGISTER_AX.Rejected,
      currentPage: 1,
      perPage: 15,
      dataBadge: null,
      fields: [
        { key: 'No', label: 'No' },
        { key: 'product_name', label: 'Product Name' },
        { key: 'external_itemid', label: 'External Item ID' },
        { key: 'discount', label: 'Discount (GAM)' },
        { key: 'vendor_name', label: 'Vendor Name' },
        { key: 'vendor_account', label: 'Vendor Account' },
        { key: 'status_item', label: 'Status Item' },
        { key: 'pisnumber', label: 'PIS Number', sortable: true },
        { key: 'dynamics_id', label: 'Dynamic ID' },
        { key: 'status_message', label: 'Status Message' },
        { key: 'releasedate_dymamics', label: 'Release Date' },
        { key: 'created', label: 'created' },
        { key: 'modified', label: 'modified', sortable: true },
        { key: 'action', label: '' },
        { key: 'retry', label: 'Retry' },
        { key: 'edit', label: 'Edit' }
      ],

      headers: [
        { label: 'no', key: ''},
        { label: 'item Name', key: 'product_name', style:'min-width:350px'},
        { label: 'External ITEM ID', key: ''},
        { label: 'Discount (GAM)', key: ''},
        { label: 'Vendor Name', key: '',style:'min-width:250px'},
        { label: 'Vendor AX', key: '',style:'min-width:130px' },
        { label: 'Status ITEM', key: '',style:'min-width:100px'},
        { label: 'PIS NO.', key: '' },
        { label: 'DYNAMIC ID', key: '',style:'min-width:120px'},
        { label: 'Message', key: '',style:'min-width:360px'},
        { label: 'Released Date', key: '' },
        { label: 'Created Date', key: 'created', slotHeader: 'header-create' },
        { label: 'Last Modified', key: 'modified', slotHeader: 'header-modified'},
      ],
      typing: '',
      searchForm: null,
      itemStatus: null,
      statusOptions: [
        {
          text: 'All Item Status',
          value: null,
        },
        ...itemStatus,
      ],
      isLoadingRetry: false,
      errorMessage: '',
      dismissSecs: 5,
      detailsData: null,
      dismissCountDown: 5,
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.registerAx.isLoading,
      isError: (state) => state.registerAx.isError,
      totalRows: (state) => state.registerAx.totalRows,
      items: (state) => state.registerAx.items,
    }),
  },
  watch: {
    currentPage() {
      this.fetchData();
    },
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Dynamic Item AX | Content Management System Ebooks Gramedia.com';
      },
    },
  },
  created() {
    this.fetchData();
  },

  methods: {
    ...mapActions('registerAx', ['fetchAllRegisterAx']),
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    sortingChanged(ctx) {
      let payload = {
        page: this.currentPage,
        limit: this.perPage,
        sort: ctx.sortBy,
        order: ctx.sortDesc ? 'desc' : 'asc'
      };
      if (this.searchForm) payload.q = this.searchForm;
      if (this.itemStatus || this.itemStatus == '0')
        payload.status_item = this.itemStatus;
      this.fetchAllRegisterAx(payload);
    },
    formatDate(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss')
      };
    },
    reset() {
      this.searchForm = ''
      this.itemStatus = null
      this.fetchData();
    },
    fetchData() {
      let payload = {
        page: this.currentPage,
        limit: this.perPage,
      };
      if (this.searchForm) payload.q = this.searchForm;
      if (this.searchForm) payload.page = this.currentPage = 1;
      if (this.itemStatus !== null && this.itemStatus !== undefined) payload.status_item = this.itemStatus;
      if (this.itemStatus !== null && this.itemStatus !== undefined) payload.page = this.currentPage = 1
      this.fetchAllRegisterAx(payload);
      this.filterBadge()
    },

    epochConvert(date) {
      const formatted = moment.unix(date);
      return {
        date: formatted.format('DD MMM YY'),
        time: formatted.format('HH:mm:ss')
      };
    },

    statusText(value) {
      const statusMap = {
        0: 'Submitted',
        1: 'Approved',
        2: 'Released',
        3: 'Rejected',
        10: 'Rejected'
      };
      return statusMap[value] || '';
    },
    statusColor(status) {
      switch (status) {
        case 0:
          return 'bg-yellow-100 text-yellow-700';
        case 1:
          return 'bg-green-100 text-green-700';
        case 2:
          return 'bg-blue-200 text-blue-800';
        case 3:
          return 'bg-red-100 text-red-700';
        case 10:
          return 'bg-red-100 text-red-700';
      }
    },
    handleModalJson(data) {
      this.detailsData = data.details
      this.$refs.modalLogJson.show();
    },
    formatTimeinfo(date) {
      return moment(date).fromNow();
    },
    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      return '0';
    },
    debounceSearch(event) {
      this.typing = 'You are typing';
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.typing = null;
        this.message = event.target.value;
        this.fetchData();
      }, 600);
    },
    onItemStatusChange() {
      this.fetchData();
    },
    filterBadge() {
      let badgeCount = 0;
      if (this.itemStatus != null) badgeCount += 1;
      this.dataBadge = badgeCount > 0 ? badgeCount : null;
    },
    sortBy(sortByCreate) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      let payload = {
        q: this.message,
        page: this.currentPage = 1,
        limit: this.perPage,
        order_by: sortByCreate,
        sort: this.sortOrder
      };

      this.fetchAllRegisterAx(payload);
    },
    objectString(data) {
      return JSON.stringify(data, null, 2);
    },
    resendItem(id) {
      this.isLoadingRetry = true;
      API.post('dynamic-item-ax/retry', { id })
        .then((res) => {
          if (res?.status == 200) {
            EventBus.$emit('show-toast', {
              message: res?.data?.data,
              type: 'success',
            });
          }
          this.fetchData()
        })
        .catch((err) => {
          EventBus.$emit('show-toast', {
            message: err?.response?.data?.data || 'Failed to resend item, please try again later',
            type: 'error',
          });
          //   this.errorMessage = err?.response?.data?.data || 'Failed to resend item, please try again later';
          this.countDownChanged(5)
        })
        .finally(() => {
          this.isLoadingRetry = false;
        })
    },
    alertMsg(message, type) {
      this.$swal({
        icon: type,
        toast: true,
        position: 'top-end',
        title: message,
        timer: 5000,
      });
    },
  },
};
</script>
<style scoped>
input::placeholder {
  font-style: italic;
}

.badge-purple {
  background-color: #ff06dc;
}

.badge-blue {
  background-color: #1c51c2;
  color: rgb(255, 255, 255);
}

.badge-lightblue {
  background-color: #10d7c0;
  color: black;
}

.json-block {
  background-color: #f9f9f9;
  font-size: 13px;
  white-space: pre-wrap;
  border-radius: 4px;

}
.w-custom {
  width: 550px;
}
.badge-red {
  background-color: #d80d25;
  color: rgb(254, 254, 254);
}
.sticky-column {
  position: sticky;
  background-color: white;
}
.-top-custom {
  top: -105px;
}
</style>
